export default __webpack_public_path__ + "static/media/roadshow_marker.76e4881a.svg";